<div class="w-100 min-vh-100 bg-white-100 container-fluid" style="background-color: #f9fafc; padding-bottom: 15px ">
  <div class="mt-5 pt-5 mx-md-4">
    <div class="d-flex align-items-center gap-2 mb-4">
      <input [(ngModel)]="query" id="search" type="text" class="form-control" placeholder="Quick Search..."
             (keydown.enter)="filterSearch(query)">
      <button class="btn d-flex align-items-center" id="searchBtn" (click)="filterSearch(query)">
        Search
        <span class="material-symbols-outlined ms-1" style="font-size: 1rem">search</span>
      </button>
    </div>

    <!-- TEACHERS -->
    <div *ngIf="filteredTeachers.length || filteredProject.length || filteredProfile.length; else noResult">
      <app-search-result-table
        [title]="'Teachers'"
        [columns]="teacherColumns"
        [data]="filteredTeachers"
        [pageSize]="pageSize"
        [currentPage]="currentPageTeachers">
      </app-search-result-table>

      <!-- PROJECTS -->
      <app-search-result-table
        [title]="'Projects'"
        [columns]="projectColumns"
        [data]="filteredProject"
        [pageSize]="pageSize"
        [currentPage]="currentPageProject">
      </app-search-result-table>

      <!-- ANNUAL PROFILE -->
      <app-search-result-table
        [title]="'Annual School Profile'"
        [columns]="profileColumns"
        [data]="filteredProfile"
        [pageSize]="pageSize"
        [currentPage]="currentPageProfile">
      </app-search-result-table>
    </div>

    <ng-template #noResult>
      <div class="col-12">
        <p class="mb-4">There are no results for this search.</p>
      </div>
    </ng-template>
  </div>
</div>
